module.exports = __webpack_public_path__ + "img/license_img.6e8bfeab.png";